import React from "react";
import Configurer from "../../components/Configurer";
import FormViewer from "../../components/FormViewer";
import LoaderButton from "../../components/LoaderButton";
import HttpServices from "../../utils/Http.services";
import { translate } from "../../utils/useful";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

class EditProfile extends React.Component {

    state = {
        headers: [
            // { key: 'image', type: 'ProfileImageInput', col: '12', information: { placeholder: '{{lang}}profileImage', required: false, } },
            { key: 'username', type: 'TextInput', col: '6', information: { label: '{{lang}}Username', icon: '', placeholder: '{{lang}}Username', required: true, disabled: true } },

            { key: 'name', type: 'TextInput', col: '6', information: { label: '{{lang}}name', icon: '', placeholder: '{{lang}}insertName', required: true } },
            { key: 'email', type: 'TextInput', col: '6', information: { label: '{{lang}}email', icon: '', placeholder: '{{lang}}insertEmail' } },
            // { key: 'phone', type: 'PhoneInput', col: '6', information: { label: '{{lang}}phone', placeholder: '{{lang}}insertPhone', disabled: false, required: false } },
            // { type: 'SwitchInput', key: 'twoFactorAuth', col: '6', information: { label: 'احراز هویت دو فاکتوری', placeholder: '{{lang}}available', default: true, required: false } },

            // { key: 'socialNumber', type: 'NumberInput', col: '6', information: { label: '{{lang}}socailNumber', maxLength: 10, icon: 'https://image.flaticon.com/icons/svg/941/941581.svg', placeholder: '{{lang}}insert', required: false } },
            // { key: 'bankAccount', type: 'NumberInput', col: '6', information: { label: '{{lang}}socailNumber',maxLength:10, icon: 'https://image.flaticon.com/icons/svg/941/941581.svg', placeholder: '{{lang}}insert', required: false } },

        ]
    }

    componentDidMount() {
        // console.log(this.props.user)
    }


    updateUserInfo = () => {
        let data = this.form.getForm()
        if (data) {
            this.setState({ isLoading: true, data }, () => {


                HttpServices.request("employeeAdd", data, (fetchResult, fetchError) => {
                    this.setState({ isLoading: false })
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.addNotif({ type: 'error', title: '{{lang}}errors.profileNotUpdated', description: fetchError.message })
                        return
                    }
                    this.setState({ errors: null })
                    this.props.setUser(fetchResult.user, null, true)
                    this.props.addNotif({ type: 'success', title: '{{lang}}info.profileUpdated', description: '{{lang}}info.profileUpdatedSuccessfully' })
                })
            })
        }
    }

    render() {
        return (

            <Configurer
                settingsInfo={{ headerTitle: translate("Edit Profile"), button: { goBack: true } }}
                title={translate("Edit Profile")}
                description={"This is the dashboard"}
                className="px-3"
                changeOnUnmount={true}
            // parentConfigure={this.props.parentConfigure??null}
            >




                <div className=" mt-4" style={{ padding: '3% 5%', }}>

                    <div className="flexcb w-100">
                        <div className="w-100">
                            <p className="text-ultra-big font-bold">{translate(translate("Edit Profile"))}</p>
                        </div>
                        <button onClick={() => this.props.openMobileMenu()} className="flexcc d-md-none " style={{ flex: 1, boxShadow: '0px 0px 15px #00000005', color: '#789' }}>
                            <img className=" " src="/images/menu.png" alt="" width="30px" />
                        </button>
                    </div>

                    {/* <p className="text-small" style={{ color: '#9ab' }}>{this.props.user.info?.fullname}</p> */}

                    <div className="w-100 mt-4">
                        <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.state.data ?? this.props.user.info} errors={this.state.errors} inputClass={` modern-input`} />

                        <div className="text-center">
                            <LoaderButton
                                onClick={this.updateUserInfo}
                                isLoading={this.state.isLoading}
                                text={"{{lang}}update"}
                                type={"Oval"}
                                className="mt-4 mb-4"
                                buttonStyle={{ outline: 'none', background: 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))', cursor: 'pointer', padding: '10px 30px', borderRadius: 50, fontSize: 15, fontWeight: '500', color: '#fff', border: 'none' }}
                                width={40}
                                height={40}
                                color={'#202020'}
                            />
                        </div>

                    </div>
                </div>




            </Configurer>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditProfile);
